import React from 'react'
import HeaderSectionReusableComponent from '../../component/ReusablaeComponent/HeaderSectionReusableComponent'
import Image_ContentReusableComponent from '../../component/ReusablaeComponent/Image_ContentReusableComponent'
import PointsWithHeading from '../../component/ReusablaeComponent/PointsWithHeading';
import IT_Transformations from '../../../Assets/IT_Transformation.png';
import IT_approch from '../../../Assets/IT_approch.png';
import Why_IT from '../../../Assets/Why_IT.png';
import Cost_optimization from '../../../Assets/Cost_optimization.png';
import Benefits_IT from '../../../Assets/Benifits_IT.png'
import PointsComponent from '../../component/ReusablaeComponent/PointsComponent';

const ITTransformation = () => {
    const IT_Transformation = [
        {
          strongText: "Industry Expertise:",
          text: "Our team has extensive experience across various industries, allowing us to deliver tailor-made IT solutions that fit your unique needs.",
        },
        {
          strongText: "End-to-End Solutions:",
          text: "From consultation and planning to implementation and support, we manage the entire IT transformation process.",
        },
        {
          strongText: "Innovation-Driven: ",
          text: "We incorporate the latest technologies like AI, machine learning, and IoT to future-proof your IT infrastructure.",
        },
      ];
      const Benefits_IT_Transformation = [
        {
          strongText: "Increased Agility:",
          text: "Quickly adapt to market changes with flexible and scalable IT solutions.",
        },
        {
          strongText: "Enhanced Security:",
          text: "Strengthen your organization’s cybersecurity posture to protect against evolving threats.",
        },
        {
          strongText: "Cost Optimization: ",
          text: "Reduce operational costs through process automation and cloud services.",
        },
        {
            strongText: "Improved User Experience: ",
            text: " Empower your teams with modern tools that enhance collaboration and productivity.",
          },
      ];
      const Process = [
        {
          strongText: "Assessment:",
          text: " In-depth analysis of your current IT landscape.",
        },
        {
          strongText: "Strategic Planning:",
          text: "Tailored roadmap to meet business goals.",
        },
        {
          strongText: "Implementation:",
          text: "Seamless integration of new technologies.",
        },
        {
            strongText: "Ongoing Support:",
            text: "Continuous monitoring and optimization.",
          },
      ];
  return (
    <div>
            <HeaderSectionReusableComponent
        mainHeading={"Transforming IT to Power Business Evolution with PTKCS"}
        paragragh={
          <>
            The digital economy demands more than just keeping up—it demands leading with innovation, speed, and resilience. At PTKCS Technologies, we help enterprises reimagine their IT landscape to meet modern challenges and future demands. Our IT transformation services are designed to streamline operations, reduce complexity, and align technology investments with your strategic goals. Whether you're just beginning your transformation or scaling up an existing one, PTKCS ensures a smooth, secure, and results-driven journey.
          </>
        }
        imgScr={IT_Transformations}
        altText='IT_Transformation'
      />
        <Image_ContentReusableComponent
        bgColor="#fff"
        heading={"Cloud-First Strategies for Agile Infrastructure"}
        paragraph={
          <>
         Modern IT starts with the cloud. PTKCS helps organizations shift from legacy systems to agile, cloud-native environments that support scalability, flexibility, and cost-efficiency. Our experts guide businesses through cloud readiness assessments, architecture design, migration, and post-deployment optimization. Whether you're adopting public, private, or hybrid cloud models, we ensure your infrastructure is built for speed, performance, and innovation. With PTKCS, you’re not just moving to the cloud—you’re maximizing its value.

          </>
        }
        imgsrc={IT_approch}
        altText='IT_approch'
        headingColor="#eb7527ff"
        headingSize="2.5rem"
      />
      <Image_ContentReusableComponent
        bgColor="#fff"
        heading={"Automation & DevOps: Fueling Faster Innovation"}
        paragraph={
          <>
         Automation is key to improving efficiency and reducing operational overhead. PTKCS integrates intelligent automation tools and DevOps practices that allow IT teams to release faster, test smarter, and operate more reliably. From CI/CD pipelines to infrastructure-as-code and automated monitoring, we embed agility into your software delivery lifecycle. This helps reduce time-to-market, eliminate manual bottlenecks, and enable a culture of continuous improvement across your IT operations.
          </>
        }
        imgsrc={IT_approch}
        reverse={false}
        altText='IT_approch'
        headingColor="#eb7527ff"
        headingSize="2.5rem"
      />
      <Image_ContentReusableComponent
        bgColor="#fff"
        heading={"Security and Governance Built into Every Layer"}
        paragraph={
          <>
         As IT environments grow more complex, security and compliance must evolve with them. PTKCS embeds robust cybersecurity frameworks into your IT transformation journey—from secure system design to real-time threat detection and response. We implement industry-compliant governance models, ensuring data integrity, user access control, and end-to-end protection across cloud, network, and application layers. Our approach not only protects your business—it builds trust with your stakeholders.

          </>
        }
        imgsrc={IT_approch}
        altText='IT_approch'
        headingColor="#eb7527ff"
        headingSize="2.5rem"
      />
      <Image_ContentReusableComponent
        bgColor="#fff"
        heading={"Data-Driven Decision-Making with Intelligent Insights"}
        paragraph={
          <>
         Digital transformation is incomplete without turning data into actionable intelligence. PTKCS integrates data analytics and business intelligence tools into your IT stack—empowering you with real-time insights that drive smarter decisions. We help businesses consolidate fragmented data sources, enable predictive analytics, and visualize KPIs that matter. From operations to customer engagement, our data-driven strategies unlock new efficiencies and growth opportunities across the board.

          </>
        }
        imgsrc={IT_approch}
        reverse={false}
        altText='IT_approch'
        headingColor="#eb7527ff"
        headingSize="2.5rem"
      />
      <Image_ContentReusableComponent
        bgColor="#fff"
        heading={"Strategic Partnership for Long-Term Digital Maturity"}
        paragraph={
          <>
        Transformation is not a one-time project—it's an ongoing journey. PTKCS partners with you beyond deployment, offering continuous support, training, and optimization to ensure sustained success. We work closely with your internal teams to build digital maturity at every level—whether it’s modernizing applications, upgrading infrastructure, or evolving your IT strategy to support innovation. Our goal is to make technology not just an enabler but a competitive advantage for your business
          </>
        }
        imgsrc={IT_approch}
        altText='IT_approch'
        headingColor="#eb7527ff"
        headingSize="2.5rem"
      />
      <PointsComponent
        title="✅ With PTKCS, IT transformation means:"
           listItems={[
          "Reduced operational costs",
          "Accelerated time-to-market",
          "Future-ready infrastructure",
          "Increased business agility",
          "Enhanced customer experience",
          "Long-term digital sustainability"

        ]}
        imageSrc={IT_approch}
        altText="EmpowerBusiness"
        reverse={false}
        headingColor="#eb7527ff"
        headingSize="2.5rem"
      />
      {/* <PointsWithHeading
        title="Why Choose Us for IT Transformation?"
        features={IT_Transformation}
        reverse={false}
        imageSrc={Why_IT}
        altText="Why_IT"
      />
        <PointsWithHeading
        title="Benefits of IT Transformation"
        bgColor='#fff'
        
        features={Benefits_IT_Transformation}
        imageSrc={Cost_optimization}
        altText="Cost_optimization"
      />
       <PointsWithHeading
        title="Why Choose Us for IT Transformation?"
        features={Process}
        reverse={false}
        imageSrc={Benefits_IT}
        altText="Benefits_IT"
      /> */}
    </div>
  )
}

export default ITTransformation